<template>
    <div>
        <ul>
            <li v-for="featu in feature" :key="featu">
                {{featu.name}}
            </li>
        </ul>
    </div>
</template>

<script>
    export default{
        props: {   
            dataItem: Object,
            columnIndex: Number    
        },
        methods: {
            
        },
        data: function() {
            return {
                item: { ...this.dataItem },
                value: ""
            };
        },
        computed: {
            feature: function(){                
                const fetureData = this.dataItem.features;
                return fetureData;
            }
            
        }
    }
    
</script>

<style scoped>
    ul {
        list-style-type: none;
    }
</style>